import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  tableCellClasses
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';
import CallCenterService from '../services/CallCenterService';
import loginListService from '../services/loginListApplication';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { GetAllAssignableStatuses, UpdateStatus } = CallCenterService;

const { ListStageStatusLogin, UpdateStageStatusesLogin } = loginListService;

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fafbfc'
  },
  '&:hover': {
    backgroundColor: '#f1f5f9'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '12px 16px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#637381',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px 16px',
    borderBottom: '1px solid #f4f6f8'
  }
}));

function UpdateLogIn() {
  const navigate = useNavigate();
  const [openFollowUp, setOpenFollowUp] = useState({ status: false, indexVal: null });
  const [loanInterested, setLoanInterested] = useState(' ');
  const [leadData, setLeadData] = useState([]);
  const [token, setToken] = useState('');
  const [companyId, setCompanyId] = useState();
  const [userId, setUserId] = useState('');
  const [statusList, setStatusList] = useState([]); // select status data from api
  const [comment, setComment] = useState('');
  const [selectedLeadId, setSelectedLeadId] = useState();
  const [refreshComp, setRefreshComp] = useState(null);
  const [validationMsg, setValidationMsg] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [updateStatusList, setUpdateStatusList] = useState([]);
  const [selectedItemList, setSelectedItemList] = useState([]);
  const [submitCred, setSubmitCred] = useState({
    companyId: null,
    updatableStatuses: [{ bankOpsLoginDetailsModel: { fileNumber: '', comments: '' } }]
  });
  // console.log('submitCred', submitCred);
  const { LoginData } = useLoginSelector();

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleUpdate = (e) => {
    if (leadData.length > 0) {
      let isCond = true;
      const objArray = [];
      leadData.forEach((item, index) => {
        // console.log('submitCred', item);
        const currKey = submitCred.updatableStatuses[index];
        if (currKey.leadStageStatusId === '~') {
          setDialogOpen(true);
          isCond = false;
          setValidationMsg('Please select status');
          return true;
        }
        if (currKey.additionalCommemts === '') {
          setDialogOpen(true);
          isCond = false;
          setValidationMsg('Please write your comments');
          return true;
        }

        // const obj = {
        //   leadId: currKey.leadId,
        //   stageCode: 'LOG_IN',
        //   stageStatusId: currKey.leadStageStatusId,
        //   userId: userId,
        //   bankOpsLoginDetailsModel: {
        //     fileNumber: '',
        //     comments: ''
        //   },
        //   comments: currKey.additionalCommemts,
        //   applicationId: item.applicationId
        // };

        const obj = {
          leadId: currKey.leadId,
          leadStageId: 58,
          stageCode: 'LOG_IN',
          stageStatusId: currKey.leadStageStatusId,
          leadStageStatusId: currKey.leadStageStatusId,
          stageId: 58,
          userId: userId,

          additionalCommemts: currKey.additionalCommemts,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      });
      // console.log('submitCred', objArray);

      const authCompanyId = LoginData?.companyId;
      const cred = {
        companyId: authCompanyId,
        updatableStatuses: objArray
      };

      if (isCond) {
        (async () => {
          const UpdateStageStatusesLoginApiResponse = await UpdateStageStatusesLogin(cred, token);
          if (UpdateStageStatusesLoginApiResponse.msg) {
            if (UpdateStageStatusesLoginApiResponse.msg === 'Forbidden') {
              navigate('/');
            }
          }
          if (UpdateStageStatusesLoginApiResponse.status === 'success') {
            navigate('/login');
          }
        })();
      }
    }

    // const UpdateStageStatusesLoginApiResponse = await UpdateStageStatusesLogin(submitCred, token);
    // if (UpdateStageStatusesLoginApiResponse.msg) {
    //   if (UpdateStageStatusesLoginApiResponse.msg === 'Forbidden') {
    //     navigate('/');
    //   }
    // }
    // if (UpdateStageStatusesLoginApiResponse.status === 'success') {
    //   navigate('/login');
    // }
  };

  useEffect(() => {
    if (LoginData === null) {
      return true;
    }
    // console.log('localJWTtoken', LoginData);
    const authToken = LoginData?.jwt;
    setToken(authToken);
    const authCompanyId = LoginData?.companyId;
    // setSubmitCred({ ...submitCred, companyId: authCompanyId });
    // setCompanyId(authCompanyId);
    const authUserId = LoginData?.userId;
    setUserId(authUserId);

    const localJWTtoken1 = JSON.parse(localStorage.getItem('selectedItem'));
    if (localJWTtoken1 === null) {
      return true;
    }
    const updatableStatusesArray = [];
    localJWTtoken1.forEach((element) => {
      // console.log('localJWTtoken1', element);
      const obj = {
        leadId: element.leadId,
        stageId: 58,
        leadStageStatusId: '~',
        additionalCommemts: ''
      };
      updatableStatusesArray.push(obj);
      setSubmitCred({
        ...submitCred,
        companyId: authCompanyId,
        updatableStatuses: updatableStatusesArray
      });
    });
    setLeadData(localJWTtoken1);
    (async () => {
      // select status api
      const credentials1 = {
        stageId: 58
      };
      const ListStageStatusLoginApiResponse = await ListStageStatusLogin(credentials1, authToken);
      if (ListStageStatusLoginApiResponse.msg) {
        if (ListStageStatusLoginApiResponse.msg === 'Forbidden') {
          navigate('/');
        }
      }
      if (ListStageStatusLoginApiResponse.status === 'success') {
        setStatusList(ListStageStatusLoginApiResponse.data.loginStageStatuses);
      }
    })();
  }, []);

  useEffect(async () => {
    const localSelectedItem = JSON.parse(localStorage.getItem('selectedItem'));

    if (LoginData !== null) {
      const authToken = LoginData?.jwt;
      const authUserId = LoginData?.userId;
      setToken(authToken);
      setUserId(authUserId);
      const GetAllAssignableStatusesApi = await GetAllAssignableStatuses('LOG_IN', authToken);
      if (GetAllAssignableStatusesApi.status === 'success') {
        GetAllAssignableStatusesApi.data.forEach((item) => {
          item.leadStatus = true;
          localSelectedItem.forEach((listItem) => {
            if (
              listItem.logInStatusName.toLowerCase() === 'u-login' &&
              (item.stageStatusName.toLowerCase() === 'u-sanction' ||
                item.stageStatusName.toLowerCase() === 'sanctioned' ||
                item.stageStatusName.toLowerCase() === 'rejected')
            ) {
              item.leadStatus = false;
            } else if (
              listItem.logInStatusName.toLowerCase() === 'login' &&
              (item.stageStatusName.toLowerCase() === 'sanctioned' ||
                item.stageStatusName.toLowerCase() === 'rejected' ||
                item.stageStatusName.toLowerCase() === 'login')
            ) {
              item.leadStatus = false;
            } else if (
              listItem.logInStatusName.toLowerCase() === 'u-sanction' &&
              item.stageStatusName.toLowerCase() !== 'sanctioned' &&
              item.stageStatusName.toLowerCase() !== 'rejected'
            ) {
              item.leadStatus = false;
            }
          });
        });

        // console.log('UpdateStatusApiUpdateStatusApi', GetAllAssignableStatusesApi.data);
        setUpdateStatusList(GetAllAssignableStatusesApi.data);
      }

      if (localSelectedItem && localSelectedItem.length > 0) {
        localSelectedItem.forEach((item, index) => {
          item.status = ' ';
          item.comments = '';
          item.bankOpsLoginDetailsModel = {
            fileNumber: '',
            comments: '',
            isSubmitClicked: false
          };
        });
        setSelectedItemList(localSelectedItem);
      } else {
        setSelectedItemList([]);
      }
    }
  }, []);

  const handleFollowUpSubmit = (e, indexVal) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    if (submitCred.updatableStatuses[indexVal].bankOpsLoginDetailsModel.fileNumber === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter file number');
      return;
    } else if (
      currentDate >
      new Date(submitCred.updatableStatuses[indexVal].bankOpsLoginDetailsModel.fileNumber)
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter valid file number');
      return;
    }

    if (submitCred.updatableStatuses[indexVal].bankOpsLoginDetailsModel.comments === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter comments');
      return;
    }

    const prevArray = submitCred;
    prevArray.updatableStatuses[indexVal].bankOpsLoginDetailsModel.isSubmitClicked = true;
    setSubmitCred({ ...prevArray });
    setOpenFollowUp({ status: false, indexVal: null });
  };

  return (
    <Page title="Kpros by Kalolytic Solutions || Log In">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Update Application Status" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              overflow: 'hidden',
              mb: 3
            }}
          >
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Application ID</StyledTableCell>
                      <StyledTableCell align="left">Application Name</StyledTableCell>
                      <StyledTableCell align="left">Bank</StyledTableCell>
                      <StyledTableCell align="left">Status</StyledTableCell>
                      <StyledTableCell align="left">Comments</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {leadData.length > 0
                      ? leadData.map((item, index) => (
                          <StyledTableRow key={index}>
                            <StyledTableCell
                              align="left"
                              sx={{ color: '#13519d', fontWeight: 600 }}
                            >
                              {item.applicationId ? item.applicationId : 'N/A'}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ fontWeight: 600 }}>
                              {item.customerName ? item.customerName : 'N/A'}
                            </StyledTableCell>
                            <StyledTableCell align="left" sx={{ color: '#637381' }}>
                              {item.bankName ? item.bankName : 'N/A'}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <Select
                                fullWidth
                                size="small"
                                inputProps={{
                                  className: `textInput textInputTable customSelectBox dissabledMenu${loanInterested}`
                                }}
                                value={submitCred.updatableStatuses[index].leadStageStatusId}
                                onChange={(e) => {
                                  setLoanInterested(e.target.value);
                                  setSelectedLeadId(item.leadId);
                                  const prevData = submitCred;
                                  prevData.updatableStatuses[index].leadStageStatusId =
                                    e.target.value;

                                  setSubmitCred(prevData);
                                  const filteredSatgeName = updateStatusList.filter(
                                    (item) => String(item.stageStatusId) === String(e.target.value)
                                  );
                                  if (
                                    filteredSatgeName.length > 0 &&
                                    filteredSatgeName[0].stageStatusName === 'Login'
                                  ) {
                                    setOpenFollowUp({ status: true, indexVal: index });
                                  }
                                  setRefreshComp(new Date());
                                }}
                                sx={{ minWidth: '200px' }}
                              >
                                <MenuItem value="~">Select Status</MenuItem>
                                {updateStatusList.length > 0
                                  ? updateStatusList.map((itemList, idx) => (
                                      <MenuItem value={itemList.stageStatusId} key={idx}>
                                        {itemList.stageStatusName}
                                      </MenuItem>
                                    ))
                                  : ''}
                              </Select>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <TextField
                                fullWidth
                                size="small"
                                inputProps={{
                                  className: 'textInput textInputTable'
                                }}
                                placeholder="Write Your Comments"
                                sx={{ minWidth: '200px' }}
                                value={submitCred.updatableStatuses[index].additionalCommemts}
                                onChange={(e) => {
                                  setComment(e.target.value);
                                  const prevData = submitCred;
                                  prevData.updatableStatuses[index].additionalCommemts =
                                    e.target.value;
                                  setSubmitCred(prevData);
                                  setRefreshComp(new Date());
                                }}
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                      : ''}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>

          <Box textAlign="right" mb={3}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#13519d',
                borderRadius: '8px',
                px: 4,
                py: 1,
                fontWeight: 600,
                '&:hover': { backgroundColor: '#0d3b75' }
              }}
              onClick={(e) => handleUpdate(e)}
            >
              Update
            </Button>

            <Dialog
              className="PopupBox"
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              open={openFollowUp.status}
              fullWidth
              PaperProps={{
                sx: { borderRadius: '16px', overflow: 'hidden' }
              }}
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Login Status</Typography>
                <IconButton
                  onClick={(e) => {
                    setOpenFollowUp({ status: false, indexVal: null });
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <FormControl required fullWidth className="formGroup">
                        <Typography
                          variant="caption"
                          sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                        >
                          File Number
                        </Typography>
                        <TextField
                          id="ApplicationNumber"
                          size="small"
                          inputProps={{ className: 'textInput' }}
                          fullWidth
                          placeholder="File Number"
                          value={
                            submitCred.updatableStatuses[openFollowUp.indexVal]
                              ?.bankOpsLoginDetailsModel.fileNumber
                          }
                          onChange={(e) => {
                            const prevArray = submitCred;
                            prevArray.updatableStatuses[
                              openFollowUp.indexVal
                            ].bankOpsLoginDetailsModel.fileNumber = e.target.value;
                            setSubmitCred({ ...prevArray });
                          }}
                        />
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box>
                      <FormControl required fullWidth className="formGroup">
                        <Typography
                          variant="caption"
                          sx={{ color: '#637381', fontWeight: 600, mb: 0.5, display: 'block' }}
                        >
                          Comments
                        </Typography>
                        <TextField
                          id="ApplicationNumber"
                          multiline
                          rows={4}
                          fullWidth
                          placeholder="Write Your Comments"
                          InputProps={{
                            classes: { root: 'textInput' }
                          }}
                          value={
                            submitCred.updatableStatuses[openFollowUp.indexVal]
                              ?.bankOpsLoginDetailsModel.comments
                          }
                          onChange={(e) => {
                            const prevArray = submitCred;
                            prevArray.updatableStatuses[
                              openFollowUp.indexVal
                            ].bankOpsLoginDetailsModel.comments = e.target.value;
                            setSubmitCred({ ...prevArray });
                          }}
                        />
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    handleFollowUpSubmit(e, openFollowUp.indexVal);
                  }}
                  variant="contained"
                  sx={{
                    backgroundColor: '#13519d',
                    borderRadius: '8px',
                    px: 3,
                    py: 0.75,
                    fontWeight: 600,
                    '&:hover': { backgroundColor: '#0d3b75' }
                  }}
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
          </Box>

          <Dialog
            open={dialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: { borderRadius: '16px', overflow: 'hidden' }
            }}
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} sx={{ color: '#13519d', fontWeight: 600 }}>
                Retry
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
export default UpdateLogIn;
